import { HTTP } from './helpers/http.js'
const search = {}

const DEFAULT_SEARCH_MAX_SIZE = 16

search.searchBy = function(startAfter, options) {
  const url = `/api/v1/organizations/${options.organizationId}/search`

  delete options.organizationId

  const payload = Object.assign({}, options)
  payload.size = DEFAULT_SEARCH_MAX_SIZE
  payload.from = startAfter

  return HTTP.post({
    url,
    payload,
  })
}

export default search
